module.exports = __webpack_public_path__ + "static/media/aladdin_snes_rugrun.3203e5ab.gif";